import * as React from "react"
import parse from "html-react-parser"
import { StaticImage } from "gatsby-plugin-image"
import cx from "classnames"

import Container from "@components/elements/container"
import Flashlight from "@components/elements/flashlight"

import styles from "./homeHero.module.scss"

const HomeHero = ({ topTitle, topText, bottomText, bottomTitle }) => {
  return (
    <section className={styles.homeHero}>
      <Flashlight className={styles.flashlight} />
      <Container className={styles.container}>
        <h1 className={styles.title}>{parse(topTitle)}</h1>
        {topText && <div className={styles.text}>{topText}</div>}

        <div className={styles.bottom}>
          {bottomText && <div className={styles.text}>{bottomText}</div>}
          {bottomTitle && (
            <div className={styles.bottomTitle}>{bottomTitle}</div>
          )}
        </div>
      </Container>
      <div className={styles.backgroundContainer}>
        <StaticImage
          className={cx(styles.backgroundPicture, styles.isDesktop)}
          objectPosition="right top"
          src="../images/bg-hero-hex.jpg"
          placeholder="dominantColor"
          alt=""
        />
        <StaticImage
          className={cx(styles.backgroundPicture, styles.isMobile)}
          objectPosition="right top"
          src="../images/bg-hero-hex-mobile.jpg"
          placeholder="dominantColor"
          alt=""
        />
      </div>
    </section>
  )
}

export default HomeHero
